import { render, staticRenderFns } from "./IconDragIndicator.vue?vue&type=template&id=39f8e345&"
import script from "./IconDragIndicator.vue?vue&type=script&lang=ts&"
export * from "./IconDragIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports